import * as React from 'react'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { EditUserDetailsForm } from '../components/EditUserDetailsForm'

interface EditUserDetailsDialogProps {
  userId: string
  editUserDetailsDialogOpen: boolean
  handleEditUserDialogClose: () => void
  productType?: string
}

export default function EditUserDetailsDialog({
  userId,
  editUserDetailsDialogOpen,
  handleEditUserDialogClose
}: EditUserDetailsDialogProps) {
  return (
    <div>
      <BootstrapDialog
        fullWidth
        sx={{ width: '80vw', maxWidth: '800px', mx: 'auto' }}
        onClose={() => handleEditUserDialogClose()}
        aria-labelledby='customized-dialog-title'
        open={editUserDetailsDialogOpen}
      >
        <BootstrapDialogTitle onClose={() => handleEditUserDialogClose()}>
          Edit user details
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ height: 'auto' }}>
          <EditUserDetailsForm
            handleClose={handleEditUserDialogClose}
            userId={userId}
          />
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
